import AddCountry from "../pages/master/country/add";
import ListCountry from "../pages/master/country/list";
import EditCountry from "../pages/master/country/edit";

import AddState from "../pages/master/state/add";
import ListState from "../pages/master/state/list";
import EditState from "../pages/master/state/edit";

import AddCity from "../pages/master/city/add";
import ListCity from "../pages/master/city/list";
import EditCity from "../pages/master/city/edit";

import AddArea from "../pages/master/area/add";
import ListArea from "../pages/master/area/list";
import EditArea from "../pages/master/area/edit";

import AddDepartment from "../pages/master/department/add";
import ListDepartment from "../pages/master/department/list";
import EditDepartment from "../pages/master/department/edit";

import AddConsultantSpecialization from "../pages/master/consultantSpecialization/add";
import ListConsultantSpecialization from "../pages/master/consultantSpecialization/list";
import EditConsultantSpecialization from "../pages/master/consultantSpecialization/edit";

import AddConsultant from "../pages/master/consultant/add";
import ListConsultant from "../pages/master/consultant/list";
import EditConsultant from "../pages/master/consultant/edit";

import AddStaff from "../pages/master/staff/add";
import ListStaff from "../pages/master/staff/list";
import EditStaff from "../pages/master/staff/edit";

import AddCase from "../pages/master/case/add";
import ListCase from "../pages/master/case/list";
import EditCase from "../pages/master/case/edit";

import AddBillingChargesGroup from "../pages/master/billingChargesGroup/add";
import ListBillingChargesGroup from "../pages/master/billingChargesGroup/list";
import EditBillingChargesGroup from "../pages/master/billingChargesGroup/edit";

import AddBillingCharges from "../pages/master/billingCharges/add";
import ListBillingCharges from "../pages/master/billingCharges/list";
import EditBillingCharges from "../pages/master/billingCharges/edit";

import AddGroupAccount from "../pages/master/groupAccount/add";
import ListGroupAccount from "../pages/master/groupAccount/list";
import EditGroupAccount from "../pages/master/groupAccount/edit";

import AddLedgerAccount from "../pages/master/ledgerAccount/add";
import ListLedgerAccount from "../pages/master/ledgerAccount/list";
import EditLedgerAccount from "../pages/master/ledgerAccount/edit";

export const mastersRoutes = [
  {
    path: `/masters/country/add`,
    Component: <AddCountry />,
    permission: "country.add"
  },
  {
    path: `/masters/country/list`,
    Component: <ListCountry />,
    permission: "country.list"
  },
  {
    path: `/masters/country/edit/:id`,
    Component: <EditCountry />,
    permission: "country.edit"
  },

  {
    path: `/masters/state/add`,
    Component: <AddState />,
    permission: "state.add"
  },
  {
    path: `/masters/state/list`,
    Component: <ListState />,
    permission: "state.list"
  },
  {
    path: `/masters/state/edit/:id`,
    Component: <EditState />,
    permission: "state.edit"
  },

  {
    path: `/masters/city/add`,
    Component: <AddCity />,
    permission: "city.add"
  },
  {
    path: `/masters/city/list`,
    Component: <ListCity />,
    permission: "city.list"
  },
  {
    path: `/masters/city/edit/:id`,
    Component: <EditCity />,
    permission: "city.edit"
  },

  {
    path: `/masters/area/add`,
    Component: <AddArea />,
    permission: "area.add"
  },
  {
    path: `/masters/area/list`,
    Component: <ListArea />,
    permission: "area.list"
  },
  {
    path: `/masters/area/edit/:id`,
    Component: <EditArea />,
    permission: "area.edit"
  },

  {
    path: `/masters/department/add`,
    Component: <AddDepartment />,
    permission: "department.add"
  },
  {
    path: `/masters/department/list`,
    Component: <ListDepartment />,
    permission: "department.list"
  },
  {
    path: `/masters/department/edit/:id`,
    Component: <EditDepartment />,
    permission: "department.edit"
  },

  {
    path: `/masters/consultant-specialization/add`,
    Component: <AddConsultantSpecialization />,
    permission: "consultantspecialization.add"
  },
  {
    path: `/masters/consultant-specialization/list`,
    Component: <ListConsultantSpecialization />,
    permission: "consultantspecialization.list"
  },
  {
    path: `/masters/consultant-specialization/edit/:id`,
    Component: <EditConsultantSpecialization />,
    permission: "consultantspecialization.edit"
  },

  {
    path: `/masters/consultant/add`,
    Component: <AddConsultant />,
    permission: "consultant.add"
  },
  {
    path: `/masters/consultant/list`,
    Component: <ListConsultant />,
    permission: "consultant.list"
  },
  {
    path: `/masters/consultant/edit/:id`,
    Component: <EditConsultant />,
    permission: "consultant.edit"
  },

  {
    path: `/masters/staff/add`,
    Component: <AddStaff />,
    permission: "staff.add"
  },
  {
    path: `/masters/staff/list`,
    Component: <ListStaff />,
    permission: "staff.list"
  },
  {
    path: `/masters/staff/edit/:id`,
    Component: <EditStaff />,
    permission: "staff.edit"
  },

  {
    path: `/masters/case/add`,
    Component: <AddCase />,
    permission: "case.add"
  },
  {
    path: `/masters/case/list`,
    Component: <ListCase />,
    permission: "case.list"
  },
  {
    path: `/masters/case/edit/:id`,
    Component: <EditCase />,
    permission: "case.edit"
  },

  {
    path: `/masters/billing-charges-group/add`,
    Component: <AddBillingChargesGroup />,
    permission: "billingchargesgroup.add"
  },
  {
    path: `/masters/billing-charges-group/list`,
    Component: <ListBillingChargesGroup />,
    permission: "billingchargesgroup.list"
  },
  {
    path: `/masters/billing-charges-group/edit/:id`,
    Component: <EditBillingChargesGroup />,
    permission: "billingchargesgroup.edit"
  },

  {
    path: `/masters/billing-charges/add`,
    Component: <AddBillingCharges />,
    permission: "billingcharges.add"
  },
  {
    path: `/masters/billing-charges/list`,
    Component: <ListBillingCharges />,
    permission: "billingcharges.list"
  },
  {
    path: `/masters/billing-charges/edit/:id`,
    Component: <EditBillingCharges />,
    permission: "billingcharges.edit"
  },

  {
    path: `/masters/group-account/add`,
    Component: <AddGroupAccount />,
    permission: "groupaccount.add"
  },
  {
    path: `/masters/group-account/list`,
    Component: <ListGroupAccount />,
    permission: "groupaccount.list"
  },
  {
    path: `/masters/group-account/edit/:id`,
    Component: <EditGroupAccount />,
    permission: "groupaccount.edit"
  },

  {
    path: `/masters/ledger-account/add`,
    Component: <AddLedgerAccount />,
    permission: "ledgeraccount.add"
  },
  {
    path: `/masters/ledger-account/list`,
    Component: <ListLedgerAccount />,
    permission: "ledgeraccount.list"
  },
  {
    path: `/masters/ledger-account/edit/:id`,
    Component: <EditLedgerAccount />,
    permission: "ledgeraccount.edit"
  }
];
